import MotrioEcosystemPage from 'pages/MotrioEcosystemPage/MotrioEcosystemPage';

export default MotrioEcosystemPage;
